<template>
    <div class="com-container">
        <div class="modal suggestion_form_modal in" v-if="isShow" style="display: block;">
            <div class="modal-dialog" style="width: 730px; top: 30px;">
                <div class="modal-content">
                    <div class="common-modal-close" @click="close">
                        <img src="../../assets/modal-close.png">
                    </div>
                    <div class="modal-body">
                        <div class="fix">
                            <div class="logo">
                                <img src="https://newwebsiteprod.oss-cn-shenzhen.aliyuncs.com/tui2/user_center/member/blue_logo.png" alt="Alternate Text">
                            </div>
                            <h3>意见建议</h3>
                            <p class="welcomeTxt">{{ suggestion.welcomeText }}</p>
                            <div class="suggestion_container">
                                <div class="tab-container">
                                    <div class="tabList">
                                        <div v-for="item in tabList" :key="item.id" class="tab sugCate" @click="selectTab(item)" v-bind:class="{active: item.id === categoryId}"><span>{{ item.name }}</span></div>
                                    </div>
                                    <div class="dropdown tab" v-bind:class="{active: dropdownActive}">
                                        <button class="dropdown-toggle" type="button" @click="showMenu">
                                            <span class="dropdownTxt">{{optionText}}</span>
                                            <span class="glyphicon glyphicon-menu-down"></span>
                                        </button>
                                        <ul class="dropdown-menu" v-if="isShowMenu" style="display: block;">
                                            <li v-for="item in optionList" :key="item.id" class="sugCate"><a href="javascript: void(0)" @click="selectOption(item)">{{ item.name }}</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="textarea">
                                    <textarea v-model="content" minlength="10" maxlength="140" class="suggestion-textarea" placeholder="具体描述（不少于10个字）"></textarea>
                                    <span class="suggestion-number">{{ content.length }}/140</span>
                                </div>
                                <div class="submitSug">
                                    <button class="submitBtn btn" @click="subSuggestion">提交建议</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 提交成功 -->
        <suggestion-sub-success ref="success" :text="successText"></suggestion-sub-success>
    </div>
</template>

<script>
    import api from '@/api'
    import SuggestionSubSuccess from './SuggestionSubSuccess'

    export default {
        name: 'Suggestion',
        components: {
            SuggestionSubSuccess
        },
        data () {
            return {
                token: '',
                isShow: false,
                suggestion: {},
                suggestionCategories: [],
                tabList: [],
                optionList: [],
                categoryId: '',
                categoryName: '',
                content: '',
                isShowMenu: false,
                optionText: '更多',
                dropdownActive: false,
                successText: '',
            }
        },
        beforeMount () {
            this.token = this.$store.state.user.userToken
        },
        methods: {
            async init () {
                this.isShow = true
                this.$loading.show()
                this.suggestion = await this.getSuggestion()
                this.$loading.hide()

                this.suggestionCategories = this.suggestion.suggestionCategories
                this.tabList = this.suggestionCategories.slice(0,3)
                this.optionList = this.suggestionCategories.slice(3)

                this.categoryId = this.tabList[0].id
                this.categoryName = this.tabList[0].name
            },
            selectTab (item) {
                this.categoryId = item.id
                this.categoryName = item.name
                this.optionText = '更多'
                this.dropdownActive = false
            },
            close () {
                this.isShow = false
                this.clearData()
            },
            showMenu () {
                this.isShowMenu = !this.isShowMenu
            },
            selectOption (item) {
                this.categoryId = item.id
                this.categoryName = item.name
                this.optionText = item.name
                this.dropdownActive = true
                this.isShowMenu = false
            },
            clearData () {
                this.categoryId = ''
                this.categoryName = ''
                this.content = ''
                this.isShowMenu = false
                this.optionText = '更多'
                this.dropdownActive = false
            },
            async getSuggestion () {
                const { errMsg, data, success } = await api.user.getSuggestionCategory(this.userToken)
                if (success) {
                    return data
                } else {
                    window.console.log(errMsg)
                }
            },
            async subSuggestion () {
                if (this.content === '') {
                    this.$alert.show('请输入意见建议')
                    return false
                }
                if (this.content.length < 10) {
                    this.$alert.show('请输入至少10字')
                    return false
                }

                this.$loading.show()
                const { errMsg, data, success } = await api.user.submitSuggestion({
                    userName: this.token,
                    content: this.content,
                    categoryName: this.categoryName,
                    categoryId: this.categoryId,
                })
                this.$loading.hide()

                if (success) {
                    this.successText = data
                    this.$refs['success'].show()
                    this.clearData()
                    this.isShow = false
                } else {
                    this.$alert.show(errMsg)
                }
            },
        }
    }
</script>

<style scoped>
    .suggestion_form_modal{
        background-color: rgba(0,0,0,0.8);
    }
    .suggestion_form_modal .modal-body .logo {
        margin-right: 5px;
    }
    .dropdown-toggle{
        width: 100%;
        height: 100%;
    }
    /*意见反馈*/
    .suggestion_form_modal .modal-body {
        padding: 4% 3%;
    }

    .suggestion_form_modal .modal-body .modal_title {
        font-size: 16px;
        color: #282b2c;
        margin-bottom: 18px;
        font-weight: bold;
    }

    .suggestion_form_modal .modal-body .modal_form .control-label {
        float: left;
        width: 80px;
        color: #747d80;
        font-weight: normal;
    }
    .suggestion_form_modal .modal-body .logo {
        width: 30px;
        display: inline-block;
        margin-bottom: 25px;
    }
    .suggestion_form_modal .modal-body .logo img {
        width: 100%;
    }
    .suggestion_form_modal .modal-body h3 {
        display: inline-block;
        margin-top: 10px;
        vertical-align: middle;
    }
    .suggestion_form_modal .modal-body p {
        font-weight: 400;
    }
    .suggestion_form_modal .modal-body .tab-container {
        margin-top: 30px;
    }
    .suggestion_form_modal .modal-body .tab {
        position: relative;
        display: inline-block;
        width: 22.5%;
        margin-left: 14px;
        padding: 15px;
        border: 1px solid #d2d9dd;
        text-align: center;
        cursor: pointer;
    }
    .suggestion_form_modal .modal-body .tab:nth-child(1) {
        margin-left: 0;
    }
    .suggestion_form_modal .modal-body .tab.active {
        background-color: #0073bb;
        color: #fff;
    }
    .suggestion_form_modal .modal-body .tab.active::after {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        left: 68px;
        bottom: -7px;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #0073bb;
    }
    .suggestion_form_modal .modal-body .tab.active:nth-child(4)::after {
        display: none;
    }
    .tabList {
        display: inline;
    }
    .suggestion_form_modal .modal-body .tab .dropdown-toggle {
        /*padding-left: 40px;*/
        background-color: #fff;
        text-align: center;
    }
    .suggestion_form_modal .modal-body .tab.active .dropdown-toggle {
        background-color: #0073bb;
    }
    .dropdown-menu > li > a {
        padding: 10px;
        text-align: center;
    }
    .dropdown-menu > li > a:focus, .dropdown-menu > li > a:hover {
        color: #fff;
        text-decoration: none;
        background-color: #54a3de;
        border-bottom: 1px solid #d4dbde;
    }

    .textarea{
        position: relative;
        margin-left: 2px;
        margin-top: 30px;
    }
    .textarea textarea {
        position: relative;
        border: 1px #d4dbde solid;
        height: 150px;
        width: 98%;
        padding: 20px;
        resize: none;
    }
    .suggestion_form_modal .modal-body .tab .glyphicon {
        /*margin-left: 30px;*/
    }

    .suggestion_form_modal .modal-body .modal_form .save_often {
        line-height: 34px;
    }

    .suggestion_form_modal .modal-body .modal_form .form-control {
        font-style: normal;
    }

    .suggestion_form_modal .modal-body .modal_title span {
        font-weight: normal;
        font-size: 14px;
        margin-left: 10px;
    }

    .suggestion_form_modal .modal-body .modal_title em {
        font-style: normal;
        color: #ff3022;
    }

    .suggestion_form_modal .modal-body .btn-default {
        display: block;
        width: 200px;
        height: 50px;
        line-height: 50px;
        padding: 0;
        border-radius: 0;
        border: none;
        font-size: 18px;
        color: #282b2c;
        background: #fbc500;
        margin: 0 auto;
    }
    .suggestion-number {
        position: absolute;
        bottom: 15px;
        right: 25px;
    }
    .submitSug {
        text-align: center;
    }
    .suggestion_form_modal .modal-body .submitBtn {
        width: 200px;
        height: 50px;
        line-height: 50px;
        padding: 0;
        border-radius: 0;
        border: none;
        font-size: 18px;
        color: #282b2c;
        background: #fbc500;
        margin-top: 20px;
    }

    /*意见反馈成功*/
    .feedSuccess_modal .modal-body {
        padding: 8% 0;
        text-align: center;
        font-size: 16px;
    }

    .feedSuccess_modal .modal-body .text {
        padding: 16px 20px 16px 16px;
        color: #282b2c;
    }
    .feedSuccess_modal .modal-body .text p{
        margin-bottom: 4px;
        font-weight: 400;
    }

    .feedSuccess_modal .modal-body .know_btn {
        color: #006ab9;
        cursor: pointer;
    }

</style>
